import { DefaultOptions, isServer, QueryCache, QueryClient, UseMutationOptions } from '@tanstack/react-query'

import { deleteCookieAction } from '@/actions/cookies/delete-cookie.action'
import { log } from '@/lib/logger'

const queryConfig = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60,
  },
  mutations: {
    // fetch err
    onError: (error) => {
      log.error('Mutation Error:', error)
      // @ts-ignore - error is not typed
      if (error.response?.status === 401) {
        // Redirect to sign-in page
        deleteCookieAction('accessToken')
        window.location.href = '/sign-in' // Adjust the path as necessary
        return
      }
    },
  },
} satisfies DefaultOptions

const makeQueryClient = () =>
  new QueryClient({
    queryCache: new QueryCache({
      onError(error) {
        if (error instanceof Error && error.message === 'Unauthorized') {
          deleteCookieAction('accessToken')
          window.location.href = '/sign-in'
          return
        }
      },
    }),
    defaultOptions: {
      ...queryConfig,
    },
  })

let browserQueryClient: QueryClient | undefined = undefined

export const getQueryClient = () => {
  if (isServer) return makeQueryClient()
  if (!browserQueryClient) browserQueryClient = makeQueryClient()
  return browserQueryClient
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiFnReturnType<FnType extends (...args: any[]) => Promise<any>> = Awaited<ReturnType<FnType>>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type QueryConfig<T extends (...args: any[]) => Promise<any>> = Omit<ReturnType<T>, 'queryKey' | 'queryFn'>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MutationConfig<MutationFnType extends (...args: any[]) => Promise<any>> = UseMutationOptions<
  ApiFnReturnType<MutationFnType>,
  Error,
  Parameters<MutationFnType>[0]
>
